<template>
  <div class="container">
    <div class="content">
      <div class="content-header">
        <img src="@/assets/img/success.png" alt="" />
        <div class="title">
          <h3>预约成功！</h3>
          <p>
            您已预约成功，请按时前往就诊。可在“<a @click="tomyServe"
              >首页-我的预约</a
            >”中查看预约记录
          </p>
        </div>
      </div>
      <p class="password" v-if="passwordNumber">取号密码：{{ passwordNumber }}</p>
      <a-button class="fontColor" size="large" @click="toHome">
        {{ jumpTime }}s &nbsp;{{ "返回首页" }}
      </a-button>
    </div>
  </div>
</template>

<script>
import { queryGuaHaoXXCX } from "@/api/registration";
export default {
  components: {},
  data() {
    return {
      jumpTime: 120,
      timer: 0,
      baseInfo: {},
      passwordNumber: "",
    };
  },
  created() {
    this.userInfo =
      sessionStorage.getItem("userInfo") &&
      JSON.parse(sessionStorage.getItem("userInfo"));

    this.passwordNumber = this.$route.query.passwordNumber
      ? this.$route.query.passwordNumber
      : "";
    if (this.$route.query.YUYUEID) {
      this.getData();
    }
  },
  mounted() {
    this.timeChange();
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  watch: {
    "$route.query": {
      handler(val) {
        if (val.baseInfo) {
          this.baseInfo = JSON.parse(val.baseInfo);
          console.log(this.baseInfo);
        }
      },
      immediate: true,
    },
  },
  methods: {
    toHome() {
      this.$router.push("/");
    },
    //获取挂号信息
    async getData() {
      let YUYUEID = this.$route.query.YUYUEID;
      let BINGRENID = this.$route.query.BINGRENID;
      let ZHENGJIANHM = this.$route.query.ZHENGJIANHM;
      let JIUZHENKH = this.$route.query.JIUZHENKH;
      let YINGYONGMC = decodeURIComponent(this.$route.query.YINGYONGMC);
      let YINGYONGID = this.$route.query.YINGYONGID;
      let params = {
        YUYUEID,
        BINGRENID,
        ZHENGJIANHM,
        JIUZHENKH,
        YINGYONGMC,
        YINGYONGID,
      };
      const { code, data } = await queryGuaHaoXXCX(params);
      if (code == 200) {
        if (data.length > 0) {
          this.passwordNumber = data[0].QUHAOMM;
        }
      }
    },
    tomyServe() {
      let actived = this.$route.query.myRegistrationActived;
      this.$router.push({
        path: "/myRegistration",
        query: {
          queryActived: actived,
        },
      });
    },
    timeChange() {
      this.timer = setInterval(() => {
        if (this.jumpTime) {
          this.jumpTime--;
        } else {
          this.$router.push({ path: "/" });
          this.delOthersVisitedRoutes({ path: "/" });
          clearInterval(this.timer);
        }
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
.fontColor1 {
  color: #fe695c;
  font-size: 14px;
}

.fontColor {
  color: #3f86ff;
  font-size: 14px;
  border: none;
}

.fontstyle {
  font-size: 14px;
  cursor: pointer;
}

.center {
  margin-top: 52px;
  text-align: center;

  .inform {
    margin: 12px 0;
  }
}

.flex {
  display: flex;
  justify-content: space-evenly;
}

.container {
  .content-header {
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 44px;
      height: 44px;
    }

    .title {
      margin-left: 20px;
      text-align: left;

      h3 {
        font-size: 20px;
        font-weight: bold;
        color: #333333;
      }

      p {
 
        font-weight: 400;
        color: #333333;
      }
    }
  }

  .content {
    text-align: center;

    > p {
      font-size: 16px;
      text-align: center;
    }
  }

  .base-info {
    margin: 20px auto;
    width: 806px;
    background: #ffffff;
    border: 1px solid #e3e3e3;
    padding: 20px;

    p {
      text-align: left;
      font-weight: 400;

      span {
        font-weight: 400;
        margin-left: 10px;
        color: #999999;
      }
    }
  }
}
.password{
  font-weight: bold;
  font-size: 16px;
}
</style>
